// extracted by mini-css-extract-plugin
export default {"chat-header":"o89TC","chat-header_preview":"ZblrV"};